/** Generated from EIssueReferenceType.java. Do not modify this file! */


export type EIssueReferenceTypeEntry = 'ISSUE' | 'SPEC_ITEM';

export class EIssueReferenceType {
	static readonly ISSUE = new EIssueReferenceType(0, 'ISSUE', "Issue");
	static readonly SPEC_ITEM = new EIssueReferenceType(1, 'SPEC_ITEM', "Specification item");
	static readonly values = [
		EIssueReferenceType.ISSUE,
		EIssueReferenceType.SPEC_ITEM
	];



	private constructor (
		public readonly ordinal: number,
		public readonly name: EIssueReferenceTypeEntry,
		public readonly readableName: string
	){
	}

	toString() {
		return this.name;
	}

	/** Returns the enum value of the provided enum entry. */
	public static valueOf(entry: EIssueReferenceTypeEntry): EIssueReferenceType;
	/** Returns the enum value of the provided enum entry. Returns undefined if entry was undefined. */
	public static valueOf(entry: EIssueReferenceTypeEntry | undefined): EIssueReferenceType | undefined;
	public static valueOf(entry: EIssueReferenceTypeEntry | undefined): EIssueReferenceType | undefined {
		if (entry === undefined) {
			return undefined;
		}
		return EIssueReferenceType[entry];
	}
}

